export const engagementCanvasTags = "/engagement/canvas/tags";
